/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const statisticsManageRouter = {
  path: '/statisticsManage',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'StatisticsManage',
  meta: {
    title: '订单统计',
    icon: 'finance',
    roles: ['admin']
  },
  children: [
    {
      path: 'payOrderMerchantSuccessRate-306',
      component: resolve => require(['@/views/manage/statisticsManage/payOrderMerchantSuccessRate'], resolve),
      name: 'PayOrderMerchantSuccessRate',
      meta: { title: '代收商户成功率', noCache: false }
    },
    {
      path: 'payOrderChannelSuccessRate-307',
      component: resolve => require(['@/views/manage/statisticsManage/payOrderChannelSuccessRate'], resolve),
      name: 'PayOrderChannelSuccessRate',
      meta: { title: '代收通道成功率', noCache: false }
    },
    {
      path: 'interceptOrderSum',
      component: resolve => require(['@/views/manage/statisticsManage/interceptOrderSum'], resolve),
      name: 'InterceptOrderSum',
      meta: { title: '代付订单拦截统计', noCache: false }
    },
    // {
    //   path: 'largeOrderStatics',
    //   component: resolve => require(['@/views/manage/statisticsManage/largeOrderStatics'], resolve),
    //   name: 'LargeOrderStatics',
    //   meta: { title: '代付大额订单比列统计', noCache: false }
    // },
    // {
    //   path: 'idCardStatics',
    //   component: resolve => require(['@/views/manage/statisticsManage/idCardStatics'], resolve),
    //   name: 'IdCardStatics',
    //   meta: { title: '身份证走量统计', noCache: false }
    // },
    {
      path: 'merchantStatics',
      component: resolve => require(['@/views/manage/statisticsManage/merchantStatics'], resolve),
      name: 'MerchantStatics',
      meta: { title: '商户走量统计', noCache: false }
    },
    {
      path: 'accountChange',
      component: resolve => require(['@/views/manage/statisticsManage/accountChange'], resolve),
      name: 'AccountChange',
      meta: { title: '账户记录', noCache: false }
    },
    {
      path: 'dayEnd',
      component: resolve => require(['@/views/manage/statisticsManage/dayEnd'], resolve),
      name: 'DayEnd',
      meta: { title: '日终统计(代收)', noCache: false }
    },
    {
      path: 'dayEndRemit',
      component: resolve => require(['@/views/manage/statisticsManage/dayEndRemit'], resolve),
      name: 'dayEndRemit',
      meta: { title: '日终统计(代付)', noCache: false }
    },
  ]
}

export default statisticsManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/statisticsManage.js